import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import PropertyList from "../../features/manageCustomers/propertyList";

import IosSwitch from "../../components/iosSwitch";
import SearchBar from "../../components/SearchBar";
import AddNote from "../../Modals/addNote";

const radioOptions = [
  {
    value: "year",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 8,000/</ins>
          <sub>Per year</sub>
        </p>
        <p>Ideal for those seeking uninterrupted, year-round access.</p>
      </div>
    ),
  },
  {
    value: "quarter",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 4,500/</ins>
          <sub>Semi-annual</sub>
        </p>
        <p>A flexible option to access full membership benefits.</p>
      </div>
    ),
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BookingDetailView = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

     const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
      setOpen1(false);
    };

  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };

  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Booking Detail
          </h1>
          <div className="right_s">
            <SearchBar searchTerm={""} placeholder={"Search offer"} />

            <Button className="btn btn_primary">
              <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
            </Button>
          </div>
        </div>

              <Box className="custom_tabs1 mb_30" sx={{ width: "100%" }}>
                    <Tabs
                      value={valueTabs}
                      onChange={handleChangeTabs}
                      aria-label="basic tabs example"
                      className="custom_tabs_links"
                    >
                      <Tab label="Booking Info" {...a11yProps(0)} />
                      <Tab label="Notes" {...a11yProps(1)} />
                 
        
                    </Tabs>
                  </Box>
 
       

           <AddNote open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
      </MainContainer>
    </>
  );
};

export default BookingDetailView;
